export default __webpack_public_path__ + "static/media/cny-188 copy.2e129341.webp";